import React from 'react';
import { Card, Badge, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons'; // ← Import direto
import { Draggable } from 'react-beautiful-dnd';

const LeadCard = ({ lead, index, onClick, onWhatsAppClick }) => { // ← onWhatsAppClick adicionado
    const getPriorityBadge = (priority) => {
        switch (priority) {
            case 'alta': return <Badge bg="danger">Alta</Badge>;
            case 'media': return <Badge bg="warning">Média</Badge>;
            default: return <Badge bg="success">Baixa</Badge>;
        }
    };

    const getTaskStatus = () => {
        if (!lead.tarefas || lead.tarefas.length === 0) return null;

        const now = new Date();
        const pendingTasks = lead.tarefas.filter(task => !task.concluida);

        if (pendingTasks.length === 0) return null;

        const isOverdue = pendingTasks.some(task => new Date(task.data_vencimento) < now);

        if (isOverdue) return { status: 'overdue', message: 'Há tarefas atrasadas!' };

        return { status: 'pending', message: 'Há tarefas pendentes' };
    };

    const taskStatus = getTaskStatus();

    const renderScore = (pontuacao) => {
        if (!pontuacao || pontuacao <= 0) return null;
        const scoreIcons = Array.from({ length: pontuacao }, (_, i) => (
            <FontAwesomeIcon key={i} icon="fire" className="text-danger" />
        ));
        return <div className="lead-score ms-2" title={`Pontuação: ${pontuacao}`}>{scoreIcons}</div>;
    };

    const getStaleLeadInfo = (lead) => {
        if (!lead.updated_at) return null;

        const now = new Date();
        const lastUpdate = new Date(lead.updated_at);
        const diffTime = Math.abs(now - lastUpdate);
        const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

        let alertInfo = null;

        switch (lead.status) {
            case 'novo':
                if (diffDays >= 2) alertInfo = { className: 'stale-lead-danger', message: `Lead parado há ${diffDays} dias.` };
                break;
            case 'contatado':
                if (diffDays >= 3) alertInfo = { className: 'stale-lead-warning', message: `Lead parado há ${diffDays} dias.` };
                break;
            case 'negociando':
            case 'aguardando':
                if (diffDays >= 2) alertInfo = { className: 'stale-lead-warning', message: `Lead parado há ${diffDays} dias.` };
                break;
            default:
                break;
        }

        return alertInfo;
    };

    const staleInfo = getStaleLeadInfo(lead);

    return (
        <Draggable draggableId={String(lead.id)} index={index}>
            {(provided, snapshot) => (
                <div
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    className={snapshot.isDragging ? 'is-dragging' : ''}
                >
                    <Card className={`mb-3 lead-card ${staleInfo ? staleInfo.className : ''}`} onClick={() => onClick(lead)} style={{ cursor: 'pointer' }}>
                        <Card.Body>
                            <div className="d-flex justify-content-between align-items-start">
                                <div className="d-flex align-items-center">

                                    {/* Ícone de sino para tarefas pendentes */}
                                    {taskStatus?.status === 'pending' && (
                                        <OverlayTrigger overlay={<Tooltip>{taskStatus.message}</Tooltip>}>
                                            <FontAwesomeIcon icon="bell" className="text-warning me-2" />
                                        </OverlayTrigger>
                                    )}
                                    {taskStatus?.status === 'overdue' && (
                                        <OverlayTrigger overlay={<Tooltip>{taskStatus.message}</Tooltip>}>
                                            <FontAwesomeIcon icon="bell" className="text-danger task-overdue-alert me-2" />
                                        </OverlayTrigger>
                                    )}

                                    <Card.Title as="h6" className="mb-1 me-2">
                                        {lead.nome.length > 10
                                            ? lead.nome.substring(0, 10) + '...'
                                            : lead.nome
                                        }
                                    </Card.Title>

                                    {/* Pontuação */}
                                    {renderScore(lead.pontuacao)}

                                    {/* Alerta de lead parado */}
                                    {staleInfo && (
                                        <OverlayTrigger overlay={<Tooltip>{staleInfo.message}</Tooltip>}>
                                            <FontAwesomeIcon icon="exclamation-triangle" className="ms-2" />
                                        </OverlayTrigger>
                                    )}
                                </div>
                                {getPriorityBadge(lead.prioridade)}
                            </div>

                            <Card.Text className="text-muted small mb-2">
                                <FontAwesomeIcon icon="phone" className="me-2" />
                                {lead.telefone}
                            </Card.Text>

                            {/* Último contato + botão WhatsApp */}
                            <div className="d-flex justify-content-between align-items-center">
                                <Card.Text className="small mb-0">
                                    <strong>Último Contato:</strong> {lead.ultimo_contato}
                                </Card.Text>

                                {/* ← BOTÃO WHATSAPP */}
                                <OverlayTrigger overlay={<Tooltip>Abrir conversa no WhatsApp</Tooltip>}>
                                    <button
                                        onClick={(e) => {
                                            e.stopPropagation(); // Evita abrir o LeadModal
                                            if (onWhatsAppClick) onWhatsAppClick(lead);
                                        }}
                                        style={{
                                            background: 'none',
                                            border: 'none',
                                            cursor: 'pointer',
                                            padding: '4px 6px',
                                            borderRadius: '50%',
                                            color: '#25d366',
                                            fontSize: '20px',
                                            lineHeight: 1,
                                            transition: 'transform 0.15s',
                                        }}
                                        onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.2)'}
                                        onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}
                                    >
                                        <FontAwesomeIcon icon={faWhatsapp} />
                                    </button>
                                </OverlayTrigger>
                            </div>
                        </Card.Body>

                        {lead.responsavel_nome && (
                            <Card.Footer className="d-flex align-items-center p-2">
                                <div className="avatar-circle me-2">
                                    {lead.responsavel_nome.substring(0, 2).toUpperCase()}
                                </div>
                                <span className="text-muted small">{lead.responsavel_nome}</span>
                            </Card.Footer>
                        )}
                    </Card>
                </div>
            )}
        </Draggable>
    );
};

export default LeadCard;